// SearchPage — German. The console's language; the record's own content stays French.
// 'Search', 'not collected', 'Could not load' and 'Loading…' live in common.de.ts and are not
// repeated here: a key translated twice warns on the console and the first one wins.
import { registerDe } from '../i18n/index.js';

registerDe({
  'Personal index': 'Eigener Index',
  'queries': 'Abfragen',
  'results': 'Treffer',
  'kept from our own SearXNG and our own snapshots':
    'behalten aus unserer eigenen SearXNG-Instanz und unseren eigenen Snapshots',

  // the box and its two verbs
  'A name, an organisation, a question…': 'Ein Name, eine Organisation, eine Frage…',
  'Search the index': 'Im Index suchen',
  'Searching…': 'Wird gesucht…',
  'Search live': 'Live suchen',
  'Skip the index and ask a provider. This one costs.':
    'Den Index überspringen und einen Anbieter fragen. Das kostet.',

  // the rail
  'Indexed queries': 'Indexierte Abfragen',
  'distinct questions the index has answered': 'verschiedene Fragen, die der Index beantwortet hat',
  'Results': 'Treffer',
  'across {n} domains': 'über {n} Domains',
  'From index · 30d': 'Aus dem Index · 30 T',
  'answered without paying a provider': 'beantwortet, ohne einen Anbieter zu bezahlen',
  'Live · 30d': 'Live · 30 T',
  '{n} provider units': '{n} Anbieter-Einheiten',
  '{n} unanswered': '{n} unbeantwortet',
  'Embedded': 'Eingebettet',
  'model unreachable': 'Modell nicht erreichbar',
  'the embedding endpoint did not answer': 'der Embedding-Endpunkt hat nicht geantwortet',
  'nothing has ever been embedded': 'es wurde noch nie etwas eingebettet',
  'of {n} embeddable results': 'von {n} einbettbaren Treffern',

  // where the answer came from
  'answered from the index · no provider was asked':
    'aus dem Index beantwortet · kein Anbieter wurde gefragt',
  'answered from the nearest query the index already held':
    'aus der nächstliegenden Abfrage beantwortet, die der Index bereits hielt',
  'answered live by a provider, through the scout':
    'live von einem Anbieter beantwortet, über den Scout',
  'no provider answered': 'kein Anbieter hat geantwortet',
  'kept until': 'gültig bis',

  // the results zone
  'Could not search': 'Suche nicht möglich',
  'Nothing asked yet. The index answers a repeated question for nothing, a paraphrase from the nearest question it already holds, and anything else through the scout — the one process with egress.':
    'Es wurde noch nichts gefragt. Eine wiederholte Frage beantwortet der Index gratis, eine Umformulierung aus der nächstliegenden Frage, die er bereits hält, und alles andere über den Scout — den einzigen Prozess mit Netzzugang.',
  'No provider answered.': 'Kein Anbieter hat geantwortet.',
  'What follows is the nearest thing the index already holds, not a live answer.':
    'Was folgt, ist das Nächstliegende, das der Index bereits hält — keine Live-Antwort.',
  'The index holds nothing near this query either, so there is nothing to show.':
    'Der Index hält auch nichts in der Nähe dieser Abfrage, also gibt es nichts zu zeigen.',
  'The provider answered, and answered with nothing.':
    'Der Anbieter hat geantwortet — und zwar mit nichts.',
  'first seen': 'zuerst gesehen',
  'last seen': 'zuletzt gesehen',
  'live': 'live',
  'from index': 'aus dem Index',
  'origin: {origin}': 'Herkunft: {origin}',

  // recent queries
  'Recent queries': 'Letzte Abfragen',
  'every question anyone asked, and how it was answered':
    'jede Frage, die jemand gestellt hat, und wie sie beantwortet wurde',
  'No query has been recorded yet.': 'Es wurde noch keine Abfrage festgehalten.',
  'Query': 'Abfrage',
  'Purpose': 'Zweck',
  'Answered': 'Beantwortet',
  'Asked by': 'Gefragt von',
  'Cost': 'Kosten',
  'When': 'Wann',
  'index': 'Index',
  'index_near': 'Index (nah)',
  'provider': 'Anbieter',
  'unavailable': 'nicht verfügbar',
  'unknown': 'unbekannt',
}, 'SearchPage');
